// 2024 Topps Chrome Black Star Wars

const BASE_P = [
  {id:'rainbow',      name:'Rainbow Refractor',        print_run:199, color:'#e0c8ff'},
  {id:'blue-red',     name:'Blue/Red Lava Refractor',  print_run:99,  color:'#ff6b6b'},
  {id:'yellow-lazer', name:'Yellow Lazer Refractor',   print_run:75,  color:'#ffee58'},
  {id:'gold',         name:'Gold Refractor',            print_run:50,  color:'#f0c040'},
  {id:'orange',       name:'Orange Refractor',          print_run:25,  color:'#ff9100'},
  {id:'magenta',      name:'Magenta RayWave Refractor', print_run:10,  color:'#e91e63'},
  {id:'red',          name:'Red Refractor',             print_run:5,   color:'#ff1744'},
  {id:'superfractor', name:'Superfractor',              print_run:1,   color:'#f0c040'},
];
const INS_P = [
  {id:'gold',         name:'Gold Refractor',   print_run:50, color:'#f0c040'},
  {id:'orange',       name:'Orange Refractor', print_run:25, color:'#ff9100'},
  {id:'red',          name:'Red Refractor',    print_run:5,  color:'#ff1744'},
  {id:'superfractor', name:'Superfractor',     print_run:1,  color:'#f0c040'},
];
const AUTO_SINGLE_P = [
  {id:'blue-red',     name:'Blue/Red Lava Refractor',  print_run:99, color:'#ff6b6b'},
  {id:'gold',         name:'Gold Refractor',            print_run:50, color:'#f0c040'},
  {id:'orange',       name:'Orange Refractor',          print_run:25, color:'#ff9100'},
  {id:'magenta',      name:'Magenta RayWave Refractor', print_run:10, color:'#e91e63'},
  {id:'red',          name:'Red Refractor',             print_run:5,  color:'#ff1744'},
  {id:'plate-cyan',   name:'Printing Plate Cyan',       print_run:1,  color:'#00e5ff'},
  {id:'plate-mag',    name:'Printing Plate Magenta',    print_run:1,  color:'#e91e63'},
  {id:'plate-yel',    name:'Printing Plate Yellow',     print_run:1,  color:'#ffee58'},
  {id:'plate-blk',    name:'Printing Plate Black',      print_run:1,  color:'#808080'},
  {id:'superfractor', name:'Superfractor',              print_run:1,  color:'#f0c040'},
];
const DUALITY_P = [
  {id:'blue-red',     name:'Blue/Red Lava Refractor', print_run:99, color:'#ff6b6b'},
  {id:'gold',         name:'Gold Refractor',           print_run:50, color:'#f0c040'},
  {id:'orange',       name:'Orange Refractor',         print_run:25, color:'#ff9100'},
  {id:'red',          name:'Red Refractor',            print_run:5,  color:'#ff1744'},
  {id:'superfractor', name:'Superfractor',             print_run:1,  color:'#f0c040'},
];
const DUAL_P = [
  // Dual Auto base card is itself /10; this serialized slot lets collectors register 1/10–10/10.
  // id 'magenta' retained (do NOT change) — collector card_keys reference it. Name blank: UI appends " /10".
  {id:'magenta',      name:'',             print_run:10, color:'#c8d8f0'},
  {id:'superfractor', name:'Superfractor', print_run:1,  color:'#f0c040'},
];
const TRIPLE_P = [
  // Triple Auto base card is itself /5; this serialized slot lets collectors register 1/5–5/5.
  // Name blank so the UI renders just "/5" (matches the Dual /10 convention in this set).
  {id:'red',          name:'',             print_run:5, color:'#c8d8f0'},
  {id:'superfractor', name:'Superfractor', print_run:1, color:'#f0c040'},
];

export const SETS = [
  {
    id: 'base', type: 'base',
    title: 'BASE SET — 100 CARDS', parallels: BASE_P,
    cards: [
      {n:'1', name:'Ahsoka Tano'},
      {n:'2', name:'Rey'},
      {n:'3', name:'Luke Skywalker'},
      {n:'4', name:'Commissioner Helgait'},
      {n:'5', name:'Grogu'},
      {n:'6', name:'Obi-Wan Kenobi'},
      {n:'7', name:'Padmé Amidala'},
      {n:'8', name:'Sabine Wren'},
      {n:'9', name:'Ezra Bridger'},
      {n:'10', name:'Leia Organa'},
      {n:'11', name:'Han Solo'},
      {n:'12', name:'Hera Syndulla'},
      {n:'13', name:'Chewbacca'},
      {n:'14', name:'Cassian Andor'},
      {n:'15', name:'Luthen Rael'},
      {n:'16', name:'Mon Mothma'},
      {n:'17', name:'Captain Rex'},
      {n:'18', name:'Saw Gerrera'},
      {n:'19', name:'Tarfful'},
      {n:'20', name:'IG-11'},
      {n:'21', name:'The Mandalorian'},
      {n:'22', name:'Supreme Chancellor Palpatine'},
      {n:'23', name:'The Armorer'},
      {n:'24', name:'Carson Teva'},
      {n:'25', name:'Bo-Katan Kryze'},
      {n:'26', name:'Huyang'},
      {n:'27', name:'K-2SO'},
      {n:'28', name:'Owen Lars'},
      {n:'29', name:'Anakin Skywalker'},
      {n:'30', name:'BB-8'},
      {n:'31', name:'Yoda'},
      {n:'32', name:'Qui-Gon Jinn'},
      {n:'33', name:'Cobb Vanth'},
      {n:'34', name:'Kelleran Beq'},
      {n:'35', name:'Poe Dameron'},
      {n:'36', name:'Wedge Antilles'},
      {n:'37', name:'Beru Lars'},
      {n:'38', name:'Ki-Adi-Mundi'},
      {n:'39', name:'C-3PO'},
      {n:'40', name:'Kit Fisto'},
      {n:'41', name:'Jar Jar Binks'},
      {n:'42', name:'Minas Velti'},
      {n:'43', name:'R2-D2'},
      {n:'44', name:'Mace Windu'},
      {n:'45', name:'Chirrut Îmwe'},
      {n:'46', name:'Lando Calrissian'},
      {n:'47', name:'Captain Enoch'},
      {n:'48', name:'Maz Kanata'},
      {n:'49', name:'Finn'},
      {n:'50', name:'General Maximilian Veers'},
      {n:'51', name:'Jyn Erso'},
      {n:'52', name:'Kylo Ren'},
      {n:'53', name:'Vel Sartha'},
      {n:'54', name:'Darth Vader'},
      {n:'55', name:'Count Dooku'},
      {n:'56', name:'General Hux'},
      {n:'57', name:'Moff Gideon'},
      {n:'58', name:'Marrok'},
      {n:'59', name:'Supreme Leader Snoke'},
      {n:'60', name:'Grand Moff Tarkin'},
      {n:'61', name:'Baylan Skoll'},
      {n:'62', name:'Shin Hati'},
      {n:'63', name:'Morgan Elsbeth'},
      {n:'64', name:'General Grievous'},
      {n:'65', name:'Jango Fett'},
      {n:'66', name:'Dryden Vos'},
      {n:'67', name:'Plo Koon'},
      {n:'68', name:'Stormtrooper'},
      {n:'69', name:'Director Krennic'},
      {n:'70', name:'The Grand Inquisitor'},
      {n:'71', name:'Dark Trooper'},
      {n:'72', name:'Fifth Brother'},
      {n:'73', name:'Young Ahsoka Tano'},
      {n:'74', name:'First Order Stormtrooper'},
      {n:'75', name:'B1 Battle Droid'},
      {n:'76', name:'Super Battle Droid'},
      {n:'77', name:'Maarva Andor'},
      {n:'78', name:'Sith Trooper'},
      {n:'79', name:'Moloch'},
      {n:'80', name:'Reva'},
      {n:'81', name:'Praetorian Guard'},
      {n:'82', name:'Death Trooper'},
      {n:'83', name:'Imperial Royal Guard'},
      {n:'84', name:'Allegiant General Pryde'},
      {n:'85', name:'Boba Fett'},
      {n:'86', name:'Nute Gunray'},
      {n:'87', name:'Cad Bane'},
      {n:'88', name:'Captain Phasma'},
      {n:'89', name:'Senator Bail Organa'},
      {n:'90', name:'Elia Kane'},
      {n:'91', name:'The Client'},
      {n:'92', name:'Valin Hess'},
      {n:'93', name:'Lang'},
      {n:'94', name:'Dedra Meero'},
      {n:'95', name:'Syril Karn'},
      {n:'96', name:'Shoretrooper'},
      {n:'97', name:'Droideka'},
      {n:'98', name:'Darth Maul'},
      {n:'99', name:'Poggle The Lesser'},
      {n:'100', name:'Grand Admiral Thrawn'},
    ],
  },
  {
    id: 'animated-sp', type: 'insert',
    title: 'ANIMATED SHORT PRINTS — 20 CARDS',
    parallels: [
      {id:'gold',         name:'Gold Refractor',            print_run:50, color:'#f0c040'},
      {id:'orange',       name:'Orange Refractor',          print_run:25, color:'#ff9100'},
      {id:'magenta',      name:'Magenta RayWave Refractor', print_run:10, color:'#e91e63'},
      {id:'red',          name:'Red Refractor',             print_run:5,  color:'#ff1744'},
      {id:'superfractor', name:'Superfractor',              print_run:1,  color:'#f0c040'},
    ],
    cards: [
      {n:'SP-1', name:'Ahsoka Tano'},
      {n:'SP-2', name:'Asajj Ventress'},
      {n:'SP-3', name:'Bo-Katan Kryze'},
      {n:'SP-4', name:'Hera Syndulla'},
      {n:'SP-5', name:'Kanan Jarrus'},
      {n:'SP-6', name:'The Grand Inquisitor'},
      {n:'SP-7', name:'Obi-Wan Kenobi'},
      {n:'SP-8', name:'Captain Rex'},
      {n:'SP-9', name:'Darth Maul'},
      {n:'SP-10', name:'Grand Admiral Thrawn'},
      {n:'SP-11', name:'Sabine Wren'},
      {n:'SP-12', name:'Savage Opress'},
      {n:'SP-13', name:'Fifth Brother'},
      {n:'SP-14', name:'Saw Gerrera'},
      {n:'SP-15', name:'Ezra Bridger'},
      {n:'SP-16', name:'Emperor Palpatine'},
      {n:'SP-17', name:'Yoda'},
      {n:'SP-18', name:'General Grievous'},
      {n:'SP-19', name:'Darth Bane'},
      {n:'SP-20', name:'Darth Vader'},
    ],
  },
  {
    id: 'darth-maul-25', type: 'insert',
    title: '25 YEARS OF DARTH MAUL — 20 CARDS',
    parallels: INS_P,
    cards: [
      {n:'DM-1', name:'Darth Maul'},
      {n:'DM-2', name:'Darth Maul'},
      {n:'DM-3', name:'Darth Maul'},
      {n:'DM-4', name:'Darth Maul'},
      {n:'DM-5', name:'Maul'},
      {n:'DM-6', name:'Maul'},
      {n:'DM-7', name:'Maul'},
      {n:'DM-8', name:'Maul'},
      {n:'DM-9', name:'Darth Maul'},
      {n:'DM-10', name:'Darth Maul'},
      {n:'DM-11', name:'Darth Maul'},
      {n:'DM-12', name:'Darth Maul'},
      {n:'DM-13', name:'Darth Maul'},
      {n:'DM-14', name:'Darth Maul'},
      {n:'DM-15', name:'Darth Maul'},
      {n:'DM-16', name:'Darth Maul'},
      {n:'DM-17', name:'Maul'},
      {n:'DM-18', name:'Darth Maul'},
      {n:'DM-19', name:'Darth Maul'},
      {n:'DM-20', name:'Darth Maul'},
    ],
  },
  {
    id: 'embrace-darkside', type: 'insert',
    title: 'EMBRACE THE DARKSIDE — 15 CARDS',
    parallels: INS_P,
    cards: [
      {n:'ED-1', name:'Darth Vader'},
      {n:'ED-2', name:'Grand Admiral Thrawn'},
      {n:'ED-3', name:'Captain Enoch'},
      {n:'ED-4', name:'Baylan Skoll'},
      {n:'ED-5', name:'Shin Hati'},
      {n:'ED-6', name:'Darth Maul'},
      {n:'ED-7', name:'Fifth Brother'},
      {n:'ED-8', name:'The Grand Inquisitor'},
      {n:'ED-9', name:'Count Dooku'},
      {n:'ED-10', name:'Kylo Ren'},
      {n:'ED-11', name:'Death Troopers'},
      {n:'ED-12', name:'Grand Moff Tarkin'},
      {n:'ED-13', name:'Moff Gideon'},
      {n:'ED-14', name:'General Grievous'},
      {n:'ED-15', name:'Darth Sidious'},
    ],
  },
  {
    id: 'depths-darkside', type: 'insert',
    title: 'DEPTHS OF THE DARKSIDE — 20 CARDS',
    parallels: INS_P,
    cards: [
      {n:'DD-1', name:'Grand Admiral Thrawn'},
      {n:'DD-2', name:'Darth Revan'},
      {n:'DD-3', name:'Emperor Palpatine'},
      {n:'DD-4', name:'Darth Maul'},
      {n:'DD-5', name:'Count Dooku'},
      {n:'DD-6', name:'Captain Enoch'},
      {n:'DD-7', name:'Death Trooper'},
      {n:'DD-8', name:'Darth Maul\'s Lightsaber'},
      {n:'DD-9', name:'Kylo Ren\'s Lightsaber'},
      {n:'DD-10', name:'Sith Wayfinder'},
      {n:'DD-11', name:'Sith Infiltrator'},
      {n:'DD-12', name:'Count Dooku\'s Lightsaber'},
      {n:'DD-13', name:'Blade of Ochi of Bestoon'},
      {n:'DD-14', name:'Sith Holocron'},
      {n:'DD-15', name:'Sith Speeder'},
      {n:'DD-16', name:'Darth Vader\'s TIE Fighter'},
      {n:'DD-17', name:'Darth Vader\'s Lightsaber'},
      {n:'DD-18', name:'The Grand Inquisitor'},
      {n:'DD-19', name:'Kylo Ren'},
      {n:'DD-20', name:'Darth Vader'},
    ],
  },
  {
    id: 'galactic-factions', type: 'insert',
    title: 'GALACTIC FACTIONS — 20 CARDS',
    parallels: INS_P,
    cards: [
      {n:'GL-1', name:'Sith'},
      {n:'GL-2', name:'Bounty Hunters'},
      {n:'GL-3', name:'Rebel Alliance'},
      {n:'GL-4', name:'New Republic'},
      {n:'GL-5', name:'Jedi Order'},
      {n:'GL-6', name:'First Order'},
      {n:'GL-7', name:'Galactic Empire'},
      {n:'GL-8', name:'Galactic Republic'},
      {n:'GL-9', name:'Fulcrum'},
      {n:'GL-10', name:'Early Rebellion'},
      {n:'GL-11', name:'General Grievous'},
      {n:'GL-12', name:'Inquisitorius'},
      {n:'GL-13', name:'The Naboo'},
      {n:'GL-14', name:'Mudhorn'},
      {n:'GL-15', name:'Phoenix'},
      {n:'GL-16', name:'Gungan'},
      {n:'GL-17', name:'Rebel Fighters'},
      {n:'GL-18', name:'Galactic Senate'},
      {n:'GL-19', name:'Desilijic'},
      {n:'GL-20', name:'Confederacy of Independent Systems'},
    ],
  },
  {
    id: 'auto-light', type: 'auto',
    title: 'AUTOGRAPH LIGHT SIDE — 77 CARDS',
    parallels: AUTO_SINGLE_P,
    cards: [
      {n:'ALS-AA', name:'Adria Arjona', artist:'Bix Caleen'},
      {n:'ALS-AB', name:'Ahmed Best', artist:'Kelleran Beq'},
      {n:'ALS-AD', name:'Anthony Daniels', artist:'C-3PO'},
      {n:'ALS-AE', name:'Ashley Eckstein', artist:'Ahsoka Tano'},
      {n:'ALS-AG', name:'Ariana Greenblatt', artist:'Young Ahsoka Tano'},
      {n:'ALS-AM', name:'Alastair McKenzie', artist:'Perrin Fertha'},
      {n:'ALS-AP', name:'Angelique Perrin', artist:'Adi Gallia'},
      {n:'ALS-AV', name:'Antonio Viña', artist:'Kassa'},
      {n:'ALS-BC', name:'Bronte Carmichael', artist:'Leida Mothma'},
      {n:'ALS-BE', name:'Blair Bess', artist:'Even Piell'},
      {n:'ALS-BL', name:'Billie Lourd', artist:'Kaydel Ko Connix'},
      {n:'ALS-BM', name:'Bobby Moynihan', artist:'Orka'},
      {n:'ALS-BR', name:'Ralph Brown', artist:'Ric Olié'},
      {n:'ALS-BS', name:'Brian Blessed', artist:'Boss Nass'},
      {n:'ALS-BW', name:'Billy Dee Williams', artist:'Lando Calrissian'},
      {n:'ALS-CE', name:'Chris Edgerly', artist:'Eeth Koth'},
      {n:'ALS-CH', name:'Hayden Christensen', artist:'Anakin Skywalker'},
      {n:'ALS-DI', name:'Ben Diskin', artist:'AZI-3'},
      {n:'ALS-DL', name:'Diego Luna', artist:'Cassian Andor'},
      {n:'ALS-DO', name:'Robin Atkin Downes', artist:'Cham Syndulla'},
      {n:'ALS-DR', name:'Daisy Ridley', artist:'Rey'},
      {n:'ALS-DY', name:'Donnie Yen', artist:'Chirrut Îmwe'},
      {n:'ALS-EE', name:'Eman Esfandi', artist:'Ezra Bridger'},
      {n:'ALS-EH', name:'Alden Ehrenreich', artist:'Han Solo'},
      {n:'ALS-EM', name:'Ewan McGregor', artist:'Obi-Wan Kenobi'},
      {n:'ALS-ES', name:'Emily Swallow', artist:'The Armorer'},
      {n:'ALS-EW', name:'Evan Whitten', artist:'Jacen Syndulla'},
      {n:'ALS-FJ', name:'Felicity Jones', artist:'Jyn Erso'},
      {n:'ALS-FM', name:'Faye Marsay', artist:'Vel Sartha'},
      {n:'ALS-FP', name:'Freddie Prinze, Jr.', artist:'Kanan Jarrus'},
      {n:'ALS-FS', name:'Fiona Shaw', artist:'Maarva Andor'},
      {n:'ALS-GB', name:'Gary Beadle', artist:'Clem Andor'},
      {n:'ALS-GO', name:'Genevieve O\'Reilly', artist:'Mon Mothma'},
      {n:'ALS-HC', name:'Hermione Corfield', artist:'Tallie Lintra'},
      {n:'ALS-HF', name:'Harrison Ford', artist:'Han Solo'},
      {n:'ALS-HQ', name:'Hugh Quarshie', artist:'Captain Panaka'},
      {n:'ALS-IV', name:'Indira Varma', artist:'Tala Durith'},
      {n:'ALS-JD', name:'Julie Dolan', artist:'Princess Leia Organa'},
      {n:'ALS-JE', name:'Joel Edgerton', artist:'Owen Lars'},
      {n:'ALS-JG', name:'Jason Spisak', artist:'Lux Bonteri'},
      {n:'ALS-JH', name:'Jessica Henwick', artist:'Jess Pava'},
      {n:'ALS-KC', name:'Keisha Castle-Hughes', artist:'Queen Apailana'},
      {n:'ALS-KF', name:'Karen Fukuhara', artist:'F'},
      {n:'ALS-KK', name:'Keira Knightley', artist:'Sabé'},
      {n:'ALS-KK-2', label:'ALS-KK', name:'Katy Kartwheel', artist:'Rio Durant'},
      {n:'ALS-KR', name:'Keri Russell', artist:'Zorii Bliss'},
      {n:'ALS-KS', name:'Katee Sackhoff', artist:'Bo-Katan Kryze'},
      {n:'ALS-LD', name:'Laura Dern', artist:'Vice Admiral Holdo'},
      {n:'ALS-MA', name:'Michelle Ang', artist:'Omega'},
      {n:'ALS-ME', name:'Maya Erskine', artist:'Sully Stark'},
      {n:'ALS-MH', name:'Mark Hamill', artist:'Luke Skywalker'},
      {n:'ALS-MQ', name:'Mike Quinn', artist:'Nien Nunb'},
      {n:'ALS-MS', name:'Meredith Salenger', artist:'Bariss Offee'},
      {n:'ALS-MW', name:'Mary Elizabeth Winstead', artist:'Hera Syndulla'},
      {n:'ALS-NA', name:'Naomi Ackie', artist:'Jannah'},
      {n:'ALS-NB', name:'Natasha Liu Bordizzo', artist:'Sabine Wren'},
      {n:'ALS-NC', name:'Nazneen Contractor', artist:'Synara San'},
      {n:'ALS-NN', name:'Nick Nolte', artist:'Kuiil'},
      {n:'ALS-NP', name:'Natalie Portman', artist:'Padmé Amidala'},
      {n:'ALS-OF', name:'Oliver Ford-Davies', artist:'Sio Bibble'},
      {n:'ALS-OI', name:'Oscar Isaac', artist:'Poe Dameron'},
      {n:'ALS-PP', name:'Pedro Pascal', artist:'The Mandalorian'},
      {n:'ALS-PR', name:'Paul Reubens', artist:'RX-24'},
      {n:'ALS-RA', name:'Riz Ahmed', artist:'Bodhi Rook'},
      {n:'ALS-RD', name:'Rosario Dawson', artist:'Ahsoka Tano'},
      {n:'ALS-SD', name:'Sharon Duncan-Brewster', artist:'Senator Tynnra Pamlo'},
      {n:'ALS-SE', name:'Amy Sedaris', artist:'Peli Motto'},
      {n:'ALS-SJ', name:'Samuel L. Jackson', artist:'Mace Windu'},
      {n:'ALS-SK', name:'Simone Kessell', artist:'Breha Organa'},
      {n:'ALS-SL', name:'Scott Lawrence', artist:'Jarek Yeager'},
      {n:'ALS-SS', name:'Stellan Skarsgård', artist:'Luthen Rael'},
      {n:'ALS-TO', name:'Timothy Olyphant', artist:'Cobb Vanth'},
      {n:'ALS-TR', name:'Tim Rose', artist:'Admiral Ackbar'},
      {n:'ALS-TW', name:'Taika Waititi', artist:'IG-11'},
      {n:'ALS-VM', name:'Vanessa Marshall', artist:'Hera Syndulla'},
      {n:'ALS-VS', name:'Varada Sethu', artist:'Cinta Kaz'},
      {n:'ALS-WD', name:'Warwick Davis', artist:'Wicket W. Warrick'},
    ],
  },
  {
    id: 'auto-dark', type: 'auto',
    title: 'AUTOGRAPH DARK SIDE — 63 CARDS',
    parallels: AUTO_SINGLE_P,
    cards: [
      {n:'ADS-AB', name:'Anna Brewster', artist:'Bazine Netal'},
      {n:'ADS-AD', name:'Adam Driver', artist:'Kylo Ren'},
      {n:'ADS-AF', name:'Alex Ferns', artist:'Sergeant Linus Mosk'},
      {n:'ADS-AL', name:'Anton Lesser', artist:'Major Partagaz'},
      {n:'ADS-AR', name:'Alan Ruscoe', artist:'Daultay Dofine'},
      {n:'ADS-AS', name:'Andy Serkis', artist:'Supreme Leader Snoke'},
      {n:'ADS-BD', name:'Benicio Del Toro', artist:'DJ'},
      {n:'ADS-BG', name:'Barbara Goodson', artist:'Mother Talzin'},
      {n:'ADS-BM', name:'Ben Mendelsohn', artist:'Director Krennic'},
      {n:'ADS-CB', name:'Claudia Black', artist:'Klothow'},
      {n:'ADS-CM', name:'Cathy Munroe', artist:'Zuckuss'},
      {n:'ADS-CO', name:'Liam Cook', artist:'Ochi of Bestoon'},
      {n:'ADS-DG', name:'Denise Gough', artist:'Dedra Meero'},
      {n:'ADS-DI', name:'Diana Lee Inosanto', artist:'Morgan Elsbeth'},
      {n:'ADS-DK', name:'Dorian Kingi', artist:'Cad Bane'},
      {n:'ADS-DO', name:'David Oyelowo', artist:'Agent Kallus'},
      {n:'ADS-DS', name:'David Shaughnessy', artist:'Myles Grint'},
      {n:'ADS-EC', name:'Emilia Clarke', artist:'Qi\'ra'},
      {n:'ADS-EK', name:'Erin Kellyman', artist:'Enfys Nest'},
      {n:'ADS-GC', name:'Gwendoline Christie', artist:'Captain Phasma'},
      {n:'ADS-GE', name:'Giancarlo Esposito', artist:'Moff Gideon'},
      {n:'ADS-GH', name:'Guy Henry', artist:'Governor Tarkin'},
      {n:'ADS-GL', name:'Domhnall Gleeson', artist:'General Hux'},
      {n:'ADS-GT', name:'George Takei', artist:'Lok Durd'},
      {n:'ADS-GW', name:'Gary Anthony Williams', artist:'Kragan Gorr'},
      {n:'ADS-HC', name:'Hayden Christensen', artist:'Darth Vader'},
      {n:'ADS-HD', name:'Harley Durst', artist:'Moloch'},
      {n:'ADS-IM', name:'Ian McDiarmid', artist:'Emperor Palpatine'},
      {n:'ADS-IS', name:'Ivanna Sakhno', artist:'Shin Hati'},
      {n:'ADS-JC', name:'Jake Cannavale', artist:'Toro Calican'},
      {n:'ADS-JG', name:'Julian Glover', artist:'General Veers'},
      {n:'ADS-JI', name:'Jason Isaacs', artist:'The Grand Inquisitor'},
      {n:'ADS-JK', name:'Jamie King', artist:'Aurra Sing'},
      {n:'ADS-KO', name:'Katy O\'Brian', artist:'Elia Kane'},
      {n:'ADS-KS', name:'Kyle Soller', artist:'Syril Karn'},
      {n:'ADS-LC', name:'Lily Cole', artist:'Lovey'},
      {n:'ADS-LE', name:'Lewis Macleod', artist:'Sebulba'},
      {n:'ADS-LL', name:'Lex Lang', artist:'Major Vonreg'},
      {n:'ADS-LM', name:'Lars Mikkelsen', artist:'Grand Admiral Thrawn'},
      {n:'ADS-MB', name:'Mark Boone Jr.', artist:'Ranzar Malk'},
      {n:'ADS-MI', name:'Moses Ingram', artist:'Reva'},
      {n:'ADS-MM', name:'Mary Elizabeth McGlynn', artist:'Governor Pryce'},
      {n:'ADS-MP', name:'Michael Pennington', artist:'Moff Jerjerrod'},
      {n:'ADS-MV', name:'Mario Vernazza', artist:'Vult Skerris'},
      {n:'ADS-MW', name:'Matthew Wood', artist:'General Grievous'},
      {n:'ADS-NF', name:'Nika Futterman', artist:'Asajj Ventress'},
      {n:'ADS-PA', name:'Philip Anthony-Rodriguez', artist:'Fifth Brother'},
      {n:'ADS-PD', name:'Paul Darnell', artist:'Marrok'},
      {n:'ADS-PJ', name:'Peter Jacobson', artist:'Myn Weaver'},
      {n:'ADS-RA', name:'Rajia Baroudi', artist:'Queen Miraj Scintel'},
      {n:'ADS-RB', name:'Richard Brake', artist:'Valin Hess'},
      {n:'ADS-RF', name:'Rupert Friend', artist:'The Grand Inquisitor'},
      {n:'ADS-RG', name:'Richard E. Grant', artist:'Allegiant General Pryde'},
      {n:'ADS-RK', name:'Rya Kihlstedt', artist:'Fourth Sister'},
      {n:'ADS-RP', name:'Ray Park', artist:'Darth Maul'},
      {n:'ADS-SE', name:'Andy Secombe', artist:'Watto'},
      {n:'ADS-SG', name:'Sarah Michelle Gellar', artist:'Seventh Sister'},
      {n:'ADS-SW', name:'Sam Witwer', artist:'Maul'},
      {n:'ADS-TB', name:'Tom Baker', artist:'Bendu'},
      {n:'ADS-TC', name:'Tim Curry', artist:'Chancellor Palpatine'},
      {n:'ADS-TM', name:'Temuera Morrison', artist:'Jango Fett'},
      {n:'ADS-WC', name:'Wes Chatham', artist:'Captain Enoch'},
      {n:'ADS-WH', name:'Werner Herzog', artist:'The Client'},
    ],
  },
  {
    id: 'auto-duality', type: 'auto',
    title: 'DUALITY OF THE GALAXY AUTOGRAPHS — 72 CARDS',
    parallels: DUALITY_P,
    cards: [
      {n:'BFA-AA', name:'Adria Arjona', artist:'Bix Caleen'},
      {n:'BFA-AB', name:'Ahmed Best', artist:'Kelleran Beq'},
      {n:'BFA-AD', name:'Adam Driver', artist:'Kylo Ren'},
      {n:'BFA-AE', name:'Alden Ehrenreich', artist:'Han Solo'},
      {n:'BFA-AF', name:'Alex Ferns', artist:'Sergeant Linus Mosk'},
      {n:'BFA-AG', name:'Ariana Greenblatt', artist:'Young Ahsoka Tano'},
      {n:'BFA-AL', name:'Anton Lesser', artist:'Major Partagaz'},
      {n:'BFA-AM', name:'Alastair McKenzie', artist:'Perrin Fertha'},
      {n:'BFA-AR', name:'Alan Ruscoe', artist:'Daultay Dofine'},
      {n:'BFA-AS', name:'Andy Serkis', artist:'Supreme Leader Snoke'},
      {n:'BFA-BD', name:'Benicio Del Toro', artist:'DJ'},
      {n:'BFA-BE', name:'Ben Mendelsohn', artist:'Director Krennic'},
      {n:'BFA-BL', name:'Billie Lourd', artist:'Kaydel Ko Connix'},
      {n:'BFA-BM', name:'Bobby Moynihan', artist:'Orka'},
      {n:'BFA-BS', name:'Bruce Spence', artist:'Tion Medon'},
      {n:'BFA-CH', name:'Hayden Christensen', artist:'Darth Vader'},
      {n:'BFA-DE', name:'Denise Gough', artist:'Dedra Meero'},
      {n:'BFA-DI', name:'Diana Lee Inosanto', artist:'Morgan Elsbeth'},
      {n:'BFA-DK', name:'Dorian Kingi', artist:'Cad Bane'},
      {n:'BFA-DL', name:'Diego Luna', artist:'Cassian Andor'},
      {n:'BFA-DP', name:'David Pasquesi', artist:'Twi\'lek Majordomo'},
      {n:'BFA-DR', name:'Daisy Ridley', artist:'Rey'},
      {n:'BFA-EE', name:'Eman Esfandi', artist:'Ezra Bridger'},
      {n:'BFA-EW', name:'Evan Whitten', artist:'Jacen Syndulla'},
      {n:'BFA-FJ', name:'Felicity Jones', artist:'Jyn Erso'},
      {n:'BFA-FM', name:'Faye Marsay', artist:'Vel Sartha'},
      {n:'BFA-FS', name:'Fiona Shaw', artist:'Maarva Andor'},
      {n:'BFA-GB', name:'Gary Beadle', artist:'Clem Andor'},
      {n:'BFA-GC', name:'Gwendoline Christie', artist:'Captain Phasma'},
      {n:'BFA-GE', name:'Giancarlo Esposito', artist:'Moff Gideon'},
      {n:'BFA-GL', name:'Domhnall Gleeson', artist:'General Hux'},
      {n:'BFA-GO', name:'Genevieve O\'Reilly', artist:'Mon Mothma'},
      {n:'BFA-HC', name:'Hayden Christensen', artist:'Anakin Skywalker'},
      {n:'BFA-HF', name:'Harrison Ford', artist:'Han Solo'},
      {n:'BFA-IM', name:'Ian McDiarmid', artist:'Emperor Palpatine'},
      {n:'BFA-IS', name:'Ivanna Sakhno', artist:'Shin Hati'},
      {n:'BFA-JC', name:'Jake Cannavale', artist:'Toro Calican'},
      {n:'BFA-JE', name:'Joel Edgerton', artist:'Owen Lars'},
      {n:'BFA-KK', name:'Keira Knightley', artist:'Sabé'},
      {n:'BFA-KR', name:'Keri Russell', artist:'Zorii Bliss'},
      {n:'BFA-KS', name:'Katee Sackhoff', artist:'Bo-Katan Kryze'},
      {n:'BFA-KY', name:'Kyle Soller', artist:'Syril Karn'},
      {n:'BFA-LA', name:'Lars Mikkelsen', artist:'Grand Admiral Thrawn'},
      {n:'BFA-LC', name:'Lily Cole', artist:'Lovey'},
      {n:'BFA-LD', name:'Laura Dern', artist:'Vice Admiral Holdo'},
      {n:'BFA-LM', name:'Lewis Macleod', artist:'Sebulba'},
      {n:'BFA-MB', name:'Mark Boone Jr.', artist:'Ranzar Malk'},
      {n:'BFA-ME', name:'Maya Erskine', artist:'Sully Stark'},
      {n:'BFA-MH', name:'Mark Hamill', artist:'Luke Skywalker'},
      {n:'BFA-MM', name:'Mary Elizabeth McGlynn', artist:'Governor Pryce'},
      {n:'BFA-MO', name:'Moses Ingram', artist:'Reva'},
      {n:'BFA-MR', name:'Mark Rolston', artist:'Captain Hayle'},
      {n:'BFA-MW', name:'Mary Elizabeth Winstead', artist:'Hera Syndulla'},
      {n:'BFA-NB', name:'Natasha Liu Bordizzo', artist:'Sabine Wren'},
      {n:'BFA-NN', name:'Nick Nolte', artist:'Kuiil'},
      {n:'BFA-NP', name:'Natalie Portman', artist:'Padmé Amidala'},
      {n:'BFA-PP', name:'Pedro Pascal', artist:'The Mandalorian'},
      {n:'BFA-RA', name:'Riz Ahmed', artist:'Bodhi Rook'},
      {n:'BFA-RB', name:'Richard Brake', artist:'Valin Hess'},
      {n:'BFA-RD', name:'Rosario Dawson', artist:'Ahsoka Tano'},
      {n:'BFA-RF', name:'Rupert Friend', artist:'The Grand Inquisitor'},
      {n:'BFA-RG', name:'Richard E. Grant', artist:'Allegiant General Pryde'},
      {n:'BFA-RP', name:'Ray Park', artist:'Darth Maul'},
      {n:'BFA-SE', name:'Andy Secombe', artist:'Watto'},
      {n:'BFA-SJ', name:'Samuel L. Jackson', artist:'Mace Windu'},
      {n:'BFA-SS', name:'Stellan Skarsgård', artist:'Luthen Rael'},
      {n:'BFA-TE', name:'Temuera Morrison', artist:'Jango Fett'},
      {n:'BFA-TM', name:'Temuera Morrison', artist:'Boba Fett'},
      {n:'BFA-TW', name:'Taika Waititi', artist:'IG-11'},
      {n:'BFA-VS', name:'Varada Sethu', artist:'Cinta Kaz'},
      {n:'BFA-WC', name:'Wes Chatham', artist:'Captain Enoch'},
      {n:'BFA-WH', name:'Werner Herzog', artist:'The Client'},
    ],
  },
  {
    id: 'auto-dual', type: 'auto',
    title: 'DUAL AUTOGRAPHS — 11 CARDS',
    parallels: DUAL_P,
    cards: [
      {n:'DA-AE', name:'Emilia Clarke / Alden Ehrenreich', artist:'Qi\'ra / Han Solo'},
      {n:'DA-DF', name:'Diego Luna / Felicity Jones', artist:'Cassian Andor / Jyn Erso'},
      {n:'DA-DO', name:'Daisy Ridley / Oscar Isaac', artist:'Rey / Poe Dameron'},
      {n:'DA-EH', name:'Ewan McGregor / Hayden Christensen', artist:'Obi-Wan Kenobi / Anakin Skywalker'},
      {n:'DA-HB', name:'Harrison Ford / Billy Dee Williams', artist:'Han Solo / Lando Calrissian'},
      {n:'DA-HI', name:'Ian McDiarmid / Hayden Christensen', artist:'Emperor Palpatine / Darth Vader'},
      {n:'DA-HS', name:'Samuel L. Jackson / Hayden Christensen', artist:'Mace Windu / Darth Vader'},
      {n:'DA-KG', name:'Giancarlo Esposito / Katee Sackhoff', artist:'Moff Gideon / Bo-Katan Kryze'},
      {n:'DA-NI', name:'Natasha Liu Bordizzo / Ivanna Sakhno', artist:'Sabine Wren / Shin Hati'},
      {n:'DA-RN', name:'Natasha Liu Bordizzo / Rosario Dawson', artist:'Sabine Wren / Ahsoka Tano'},
      {n:'DA-TM', name:'Temuera Morrison / Ming-Na Wen', artist:'Boba Fett / Fennec Shand'},
    ],
  },
  {
    id: 'auto-triple', type: 'auto',
    title: 'TRIPLE AUTOGRAPHS — 6 CARDS',
    parallels: TRIPLE_P,
    cards: [
      {n:'TA-ADI', name:'Daisy Ridley / Adam Driver / Ian McDiarmid', artist:'Rey / Kylo Ren / Emperor Palpatine'},
      {n:'TA-ADO', name:'Adam Driver / Oscar Isaac / Daisy Ridley', artist:'Kylo Ren / Poe Dameron / Rey'},
      {n:'TA-DFD', name:'Felicity Jones / Donnie Yen / Diego Luna', artist:'Jyn Erso / Chirrut Îmwe / Cassian Andor'},
      {n:'TA-LWD', name:'Diana Lee Inosanto / Lars Mikkelsen / Wes Chatham', artist:'Morgan Elsbeth / Grand Admiral Thrawn / Captain Enoch'},
      {n:'TA-OKD', name:'Daisy Ridley / Keri Russell / Oscar Isaac', artist:'Rey / Zorii Bliss / Poe Dameron'},
      {n:'TA-RNL', name:'Natasha Liu Bordizzo / Lars Mikkelsen / Rosario Dawson', artist:'Sabine Wren / Grand Admiral Thrawn / Ahsoka Tano'},
    ],
  },
];

export const PARALLELS = BASE_P;
export const AUTO_PARALLELS = AUTO_SINGLE_P;
export const INSERT_PARALLELS = INS_P;
